import { render, staticRenderFns } from "./VarFormItem.vue?vue&type=template&id=10c1261a"
import script from "./VarFormItem.vue?vue&type=script&lang=js"
export * from "./VarFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports